var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 7,
  viewBox: "0 0 11 7"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#528AEA",
  fillRule: "evenodd",
  d: "M2.4 1.212l2.746 2.747a1 1 0 0 0 1.415 0l2.747-2.747a.891.891 0 0 1 1.26 1.26L6.561 6.48a1 1 0 0 1-1.415 0L1.14 2.472a.891.891 0 0 1 1.26-1.26z",
  opacity: .9
})));
export default __webpack_public_path__ + "teg/media/downArrow.18849304.svg";
export { SvgComponent as ReactComponent };